import React from "react";
import styles from "./PrettyCopyBox.module.scss";
import { CopyClickableIcon } from "./CopyClickableIcon.jsx";
import { TurnrCard } from "../card/TurnrCard.jsx";

export function PrettyCopyBox({ text, copyText = text, copyHoverText, fullWidth }) {
    return (
        <TurnrCard style={{ height: "100%", width: fullWidth ? "100%" : "fit-content" }}>
            <div
                style={{
                    overflow: "hidden",
                    position: "relative",
                    width: "100%",
                    height: "100%",
                    display: "flex",
                }}
            >
                <div style={{ padding: "10px 20px", width: fullWidth && "100%" }}>{text}</div>
                <div className={styles["copy-button-wrapper"]}>
                    <CopyClickableIcon
                        style={{
                            width: "100%",
                            height: "100%",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                        }}
                        text={copyText}
                        fontSize={"14px"}
                        copyHoverText={copyHoverText}
                        alwaysShowIcon={true}
                        showText={false}
                    />
                </div>
            </div>
        </TurnrCard>
    );
}
